/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsPricingMortgagePricingValidationError {
    

    type?: LDCLPBPPublicApiModelsPricingMortgagePricingValidationError.TypeEnum;

    description?: string;
}
export namespace LDCLPBPPublicApiModelsPricingMortgagePricingValidationError {

    export enum TypeEnum { 
        None = <any> 'None',
        Retail = <any> 'Retail',
        LoanPurpose = <any> 'LoanPurpose',
        PropertyType = <any> 'PropertyType',
        OccupancyType = <any> 'OccupancyType',
        AppraisedValueOrSalesPrice = <any> 'AppraisedValueOrSalesPrice',
        YearAcquired = <any> 'YearAcquired',
        HazardInsurance = <any> 'HazardInsurance',
        LoanAmount = <any> 'LoanAmount',
        SubjectPropertyAddress = <any> 'SubjectPropertyAddress',
        SubjectPropertyStateNotSupported = <any> 'SubjectPropertyStateNotSupported',
        SecondMortgage = <any> 'SecondMortgage',
        RefiHasFHALoan = <any> 'RefiHasFHALoan',
        RefiHasVALoan = <any> 'RefiHasVALoan',
        RefiMissingYearBuilt = <any> 'RefiMissingYearBuilt',
        PropertyMultiUnit = <any> 'PropertyMultiUnit',
        Throttled = <any> 'Throttled',
        YearBuiltMissing = <any> 'YearBuiltMissing',
        Declarations = <any> 'Declarations',
        CreditPullMissingOrNotTriMerge = <any> 'CreditPullMissingOrNotTriMerge',
        CreditReportMissing = <any> 'CreditReportMissing',
        LowCreditScore = <any> 'LowCreditScore',
        WillNotOccupy = <any> 'WillNotOccupy',
        RecentBankruptcy = <any> 'RecentBankruptcy',
        NoAssets = <any> 'NoAssets',
        BadBankAccountAsset = <any> 'BadBankAccountAsset',
        BadEquityAsset = <any> 'BadEquityAsset',
        BadVestRetFundAsset = <any> 'BadVestRetFundAsset',
        PersonalInformation = <any> 'PersonalInformation',
        Income = <any> 'Income',
        Address = <any> 'Address',
        Employment = <any> 'Employment',
        USCitizenship = <any> 'USCitizenship',
        LiabilityMortgage = <any> 'LiabilityMortgage',
        LiabilityRentingMortgage = <any> 'LiabilityRentingMortgage',
        LiabilitiesNotMapped = <any> 'LiabilitiesNotMapped',
        CreditMissingForSSN = <any> 'CreditMissingForSSN',
        OccupancyTypeSecondOrInvestment = <any> 'OccupancyTypeSecondOrInvestment',
        PropertyStatusRetained = <any> 'PropertyStatusRetained',
        PropertyStatusPendingSale = <any> 'PropertyStatusPendingSale',
        InvalidIncomeType = <any> 'InvalidIncomeType',
        RefiCurrentAndPropertyAddressMismatch = <any> 'RefiCurrentAndPropertyAddressMismatch',
        NonSpouseCoBorrower = <any> 'NonSpouseCoBorrower',
        CoBorrowerIsVAEligible = <any> 'CoBorrowerIsVAEligible',
        CoBorrowerNoCreditConsent = <any> 'CoBorrowerNoCreditConsent',
        CoBorrowerInvalidCredentials = <any> 'CoBorrowerInvalidCredentials',
        DUFailed = <any> 'DUFailed',
        NonUSIPAddress = <any> 'NonUSIPAddress',
    }
}
